module.exports = __webpack_public_path__ + "static/media/entry.33270a2c.png";